import { getCart } from './cart';
import toast from 'react-hot-toast';

/**
 * Direct checkout function that syncs cart with WordPress and redirects to WooCommerce checkout
 * This replaces the need for a separate checkout page
 */
export const proceedToCheckout = async (currency = 'USD', exchangeRate = 1) => {
  try {
    const cart = getCart();

    if (!cart || !cart.items || cart.items.length === 0) {
      toast.error('Your cart is empty');
      return;
    }

    const sessionId = `bb_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const cartData = {
      items: cart.items.map((item) => ({
        product_id: item.id,
        variation_id: item.variation_id || 0,
        quantity: item.quantity,
        price: item.price,
        name: item.name,
        image: item.image,
        attributes: item.attributes || [],
        sku: item.sku,
      })),
      totals: {
        subtotal: cart.total,
        tax: cart.total * 0.08,
        total: cart.total + cart.total * 0.08,
      },
      currency: currency,
      exchange_rate: exchangeRate
    };

    // Store cart data in session storage
    sessionStorage.setItem('bailebelle_cart_data', JSON.stringify(cartData));
    sessionStorage.setItem('bailebelle_session_id', sessionId);

    // Show loading toast
    toast.loading('Processing checkout...', { id: 'checkout' });

    // Sync with WordPress
    const syncResponse = await fetch(
      'https://shop.bailebelle.com/wp-json/bailebelle/v1/sync-cart',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: sessionId,
          cart_items: cartData.items,
          currency: currency,
          exchange_rate: exchangeRate
        }),
      }
    );

    const syncResult = await syncResponse.json();
    if (!syncResult.success) {
      throw new Error('Failed to sync cart with WordPress');
    }

    // Get checkout URL
    const checkoutResponse = await fetch(
      `https://shop.bailebelle.com/wp-json/bailebelle/v1/checkout-url?session_id=${sessionId}&redirect_url=${encodeURIComponent(
        window.location.origin + '/orders/success'
      )}`
    );

    const checkoutResult = await checkoutResponse.json();

    if (!checkoutResult.success || !checkoutResult.checkout_url) {
      throw new Error('Failed to get checkout URL');
    }

    // Dismiss loading toast
    toast.dismiss('checkout');

    // Redirect to WooCommerce checkout page
    window.location.href = checkoutResult.checkout_url;

  } catch (error) {
    console.error('Checkout error:', error);
    toast.dismiss('checkout');
    toast.error('Checkout failed. Please try again.');
  }
};
